(ns machtfit.subsidy-rate.options
  "Pure helpers for filtering offer-architecture option lists in the subsidy
  rule editor (dependent dropdowns).")

(defn service-formats-for-delivery-type [service-formats delivery-type-slug]
  (if delivery-type-slug
    (filter #(= (:delivery-type-slug %) delivery-type-slug) service-formats)
    service-formats))

(defn health-categories-for-domain [health-categories domain-slug]
  (if domain-slug
    (filter #(some #{domain-slug} (:domain-slugs %)) health-categories)
    health-categories))

(defn toggle-slug [slugs slug]
  (if (some #{slug} slugs)
    (vec (remove #{slug} slugs))
    (conj (vec slugs) slug)))
